import $ from 'jquery';
import CurrencyConverter from 'shopify-currency-converter';
import { removeTrapFocus, trapFocus } from '@shopify/theme-a11y';
import Forms from '../Forms';
import VariantHelper from '../VariantHelper';
import AddToCartFlyout from './AddToCartFlyout';
import ProductGallery from './ProductGallery';

export default class ProductDetails {
  constructor(options) {
    this.$window = $(window);
    this.$formArea = options.$formArea;
    this.$gallery = options.$gallery;
    this.$details = options.$details;
    this.context = options.context;
    this.settings = options.settings;
    this.product = options.product;
    this.useHistory = options.useHistory;

    this.variantHelper = null;

    this.atcCallbacks = options.atcCallbacks;

    // Form
    this.$form = this.$formArea.find('[data-product-form]');
    this.$productAtcButton = this.$formArea.find('[data-product-atc]');
    this.$productVariants = this.$form.find('[data-variants]');
    this.$productOptions = this.$form.find('[data-product-option]');

    this.variantFields = {
      $price: this.$details.find('[data-price]'),
      $priceMoney: this.$details.find('[data-price] .money'),
      $compareAtPrice: this.$details.find('[data-price-compare-at]'),
      $compareAtPriceMoney: this.$details.find('[data-price-compare-at] .money'),
      $badge: this.$details.find('[data-badge-sales]'),
      $badgeMoneySaved: this.$details.find('[data-price-money-saved]'),
      $badgePercentSaved: this.$details.find('[data-price-percent-saved]'),
      $sku: this.$details.find('[data-product-sku]'),
    };

    this.forms = new Forms(this.$form);
    this.gallery = new ProductGallery(options);

    // Stock Label - Grab data from global
    this.stock_variants = window.stock_variants || null;
    this.outStockLabels = [];
    this.$parent        = this.$form.parents('[data-product-wrapper]').first();
    this.$qty           = this.$form.find('[data-quantity-select]').first();
    this.$qtyInput      = this.$form.find('[data-quantity-input]').first();
    for (let x of this.$parent.find('.out-stock-block.stock-details')) {
      x = $(x)
      this.outStockLabels.push({index: x.data('index'), vendor: x.data('vendor').split('|').map(function(e) { return e.trim()})})
    }

    this._bindEvents();
    this._initOptions();
    // Installment Init
    this._initInstallmentPopup();
    // Init Stock Label
    this._updateStockLabel({id: this.$parent.find('select[name=id], input[name=id]').first().val()});
  }

  unload() {
    this.$form.off('.product-details');
    this.forms.unload();

    if (this.variantHelper) {
      this.variantHelper.unload();
    }

    this.gallery.unload();
  }

  _bindEvents() {
    this.$window.on('product-variant-switch.product-details', (event, data) => this._switchVariant(event, data));
    this.$form.on('submit.product-details', event => this._AddToCartFlyout(event));
    // Installment
    this._bindInstallmentEvent();
    // Quantiy for stock label
    this._bindQuantiyEvent();
    // Read more
    let $readmoreBtns = $('.container-readmore.shown', this.$form).click((e) => {
      let dom = e.currentTarget;
        dom.classList.remove('shown');
        dom = dom.parentNode.querySelector('.container-desc');
        if (!dom) return;
        dom.classList.add('shown');
    });
  }

  _initOptions() {
    if (!this.$productVariants.length) return;

    this.variantHelper = new VariantHelper(
      this.product,
      this.$productVariants,
      this.$productOptions,
    );
  }

  // Inject Popup
  _initInstallmentPopup() {
    document.querySelector('body').insertAdjacentHTML('beforeend', $('#installment-popup-template').html());
    $('.modal-mask .modal-header .close').on('click', function(e) {
      e.stopPropagation();
      $(this).parents('.modal-mask').toggleClass('hidden');
    });

    $('.modal-mask').on('click', function() {
      $(this).toggleClass('hidden');
    });
  }

  _bindInstallmentEvent() {
    this.$parent.find('.installment-logo div').click(function() {
      let selector = '[data-{name}-popup]'.replace('{name}', $(this).data('popup'));
      $(selector).removeClass('hidden');
    });
  }

  _bindQuantiyEvent() {
    this.$qty.change(e => {
      this._updateStockLabel(
        {id: this.variantHelper.$variants.val()},
        parseInt(e.currentTarget.value)
      );
    })
    this.$qtyInput.change(e => {
      this._updateStockLabel(
        {id: this.variantHelper.$variants.val()},
        parseInt(e.currentTarget.value)
      );
    })
  }

  _switchVariant(event, data) {
    if (data.product !== this.product) return;

    const variant = data.variant;
    const firstLoad = data.firstLoad;

    if (firstLoad) {
      return;
    }

    // Update main select
    this.$productVariants.val(data.variant.id);
    this.gallery.variantChange(variant);

    // Update Variant information
    this._updatePrice(variant);
    this._updateSKU(variant);
    this._updateBadge(variant);
    this._updateButton(variant);
    this._updateStockLabel(variant, parseInt(this.$qty.val()));
    this._updateInstallment(variant);

    if (this.useHistory) {
      const url = `${ this.product.handle }?${$.param({ variant: variant.id })}`;
      history.replaceState({}, 'variant', url);
    }
  }

  _updatePrice(variant) {
    // Update compare at price
    const hasComparePrice = (
      !!variant.compare_at_price && variant.compare_at_price > variant.price
    );
    this.variantFields.$compareAtPrice.toggleClass('visible', hasComparePrice);
    this.variantFields.$compareAtPriceMoney.text(Shopify.formatMoney(variant.compare_at_price, this.settings.money_format));
    CurrencyConverter.update(this.variantFields.$compareAtPriceMoney[0]);

    // Update price
    this.variantFields.$priceMoney.text(Shopify.formatMoney(variant.price, this.settings.money_format));
    CurrencyConverter.update(this.variantFields.$priceMoney[0]);
  }

  _updateSKU(variant) {
    if (variant.sku === '') {
      this.variantFields.$sku.parent().addClass('product-sku--empty');
    } else {
      this.variantFields.$sku.parent().removeClass('product-sku--empty');
    }

    this.variantFields.$sku.text(variant.sku);
  }

  _updateBadge(variant) {
    const priceSaved = variant.compare_at_price ? variant.compare_at_price - variant.price : 0;
    this.variantFields.$badge.toggle(!!priceSaved);

    if (this.variantFields.$badgeMoneySaved.length) {
      // Update badge if it shows money saved
      this.variantFields.$badgeMoneySaved.text(Shopify.formatMoney(priceSaved, this.settings.money_format));
      CurrencyConverter.update(this.variantFields.$badgeMoneySaved[0]);
    }

    if (this.variantFields.$badgePercentSaved.length) {
      // Update badge if it shows percentiles
      const percentileSaved = Math.round((priceSaved * 100) / variant.compare_at_price);
      this.variantFields.$badgePercentSaved.text(percentileSaved);
    }
  }

  _updateButton(variant) {
    if (variant.available) {
      this.$productAtcButton.text(this.context.product_available);
      this.$productAtcButton
        .removeClass('disabled')
        .prop('disabled', false);
    } else {
      this.$productAtcButton.text(this.context.product_unavailable);
      this.$productAtcButton
        .addClass('disabled')
        .prop('disabled', true);
    }
  }

  // PS Stock Label
  _updateStockLabel(variant, qty = 1) {
    if (this.stock_variants == null) {
      return;
    }

    let vendor = this.product.vendor,
    currentID = this.stock_variants.length <= 1 ? this.stock_variants[0] : this.stock_variants.find(function(e) {
      return e.id == variant.id
    }), target;

    if (parseInt(currentID.qty) >= qty) {
      target = this.$parent.find('.stock-details.in-stock-block');
      this.$parent.find('.stock-details').not('.in-stock-block').addClass('hidden');
      target.removeClass('hidden');
    } else {
      let index = this.outStockLabels.find(function(val) {
        return val.vendor.indexOf(vendor) !== -1;
      }) || {index: null}, selector = '[data-index={index}]'.replace('{index}', index['index']);
      target = this.$parent.find('.stock-details.out-stock-block' + selector);
      this.$parent.find('.stock-details').not(selector).addClass('hidden');
      target.removeClass('hidden');
    }
  }

  // PS Installment breakdown
  _updateInstallment(variant) {
    let $installment = this.$parent.find('.product-inner-layout .installment');
    $installment.text(Shopify.formatMoney(variant.price / 10, this.settings.money_format));
    CurrencyConverter.update($installment[0]);
  }

  _AddToCartFlyout(event) {
    event.preventDefault();

    const formData = this.$form.serializeArray();

    const options = {
      $atcButton: this.$productAtcButton,
      settings: {
        moneyFormat: this.settings.money_format,
        cartRedirection: this.settings.cart_redirection,
      },
      // Upsell
      handle: this.product.handle,
    };

    AddToCartFlyout.init(formData, options, this.atcCallbacks);
  }
}
